import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";
import { ResponseUtils } from '../response-utils';

export const KYMW1319Handlers = [
  // 企画商品特集商品情報取得 /kymw13/getDeletePlanGoodsInfo
  http.post(PlessService.SERVICE.getSelectedPlanGoodsFeatureList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getSelectedPlanGoodsFeatureListResponce);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  // 特集情報取得 /kymw13/getFeatureThemaListForUpdate
  http.post(PlessService.SERVICE.getFeatureThemaListForUpdate.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getFeatureThemaListForUpdateResponce);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  // 企画商品特集商品情報更新 /kymw13/updatePlanGoodsFeature
  http.post(PlessService.SERVICE.updatePlanGoodsFeature.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(updatePlanGoodsFeatureResponce);
    // return HttpResponse.json(updateFail);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  // 特集用束ね企画情報取得 /kymw13/getBundleCatalogInfoForFeature
  http.post(PlessService.SERVICE.getBundleCatalogInfoForFeature.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getBundleCatalogInfoForFeatureResponce_workNum6);
    // return HttpResponse.json(getBundleCatalogInfoForFeatureResponce_workNum7);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
]

const getSelectedPlanGoodsFeatureListResponce = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      SelectedFeatureList: [
        {
          OrderCode: "2023300",
          CatalogFixedFlag: "1",
          FeatureCode: "00101",
          FeatureName: "特集1"
        },
        {
          OrderCode: "2023310",
          CatalogFixedFlag: "0",
          FeatureCode: "00101",
          FeatureName: "特集1"
        },
        {
          OrderCode: "2023320",
          CatalogFixedFlag: "0",
          FeatureCode: "00102",
          FeatureName: "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９"
        }
      ]
    }
  }
}

const getFeatureThemaListForUpdateResponce = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      FeatureInfoList: [
        {
          FeatureCode: "00101",
          FeatureName: "特集名1",
        },
        {
          FeatureCode: "00102",
          FeatureName: "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９",
        }
      ]
    }
  }
}

const updatePlanGoodsFeatureResponce = {
  status: "ok",
  message: "処理終了",
}

const updateFail = {
  status: 'plessError',
  message: '受注コード：{0}に対して、特集コード：{1}が存在しません。',
  errorcode: 'E0606',
  strings: ['2023300', '00101'],
}

const getBundleCatalogInfoForFeatureResponce_workNum6 = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      StartOrderCode:"2023300",
      EndOrderCode:"999999",
      BundleCatalogRoundName:"０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９",
      ProgressWorkNum:"6"
    }
  }
}

const getBundleCatalogInfoForFeatureResponce_workNum7 = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      StartOrderCode:"2023300",
      EndOrderCode:"9999999",
      BundleCatalogRoundName:"2025年1号（ハピデリ）",
      ProgressWorkNum:"7"
    }
  }
}